export const GET_DATA_REQUEST = 'GET_DATA_REQUEST'
export const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS'
export const GET_DATA_FAIL = 'GET_DATA_FAIL'

export const SAVE_SERIES_REQUEST ='SAVE_SERIES_REQUEST'
export const SAVE_SERIES_SUCCESS ='SAVE_SERIES_SUCCESS'
export const SAVE_SERIES_FAIL ='SAVE_SERIES_FAIL'
export const SAVE_SERIES_RESET ='SAVE_SERIES_RESET'

export const UPDATE_SERIES_REQUEST ='UPDATE_SERIES_REQUEST'
export const UPDATE_SERIES_SUCCESS ='UPDATE_SERIES_SUCCESS'
export const UPDATE_SERIES_FAIL ='UPDATE_SERIES_FAIL'
export const UPDATE_SERIES_RESET ='UPDATE_SERIES_RESET'

export const GET_COUNTRIES_REQUEST = 'GET_COUNTRIES_REQUEST'
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS'
export const GET_COUNTRIES_FAIL = 'GET_COUNTRIES_FAIL'
export const GET_COUNTRIES_RESET = 'GET_COUNTRIES_RESET'

export const GET_UNITS_REQUEST = 'GET_UNITS_REQUEST'
export const GET_UNITS_SUCCESS = 'GET_UNITS_SUCCESS'
export const GET_UNITS_FAIL = 'GET_UNITS_FAIL'
export const GET_UNITS_RESET = 'GET_UNITS_RESET'

export const GET_COUNTRY_DATA_REQUEST = 'GET_COUNTRY_DATA_REQUEST'
export const GET_COUNTRY_DATA_SUCCESS = 'GET_COUNTRY_DATA_SUCCESS'
export const GET_COUNTRY_DATA_FAIL = 'GET_COUNTRY_DATA_FAIL'
export const GET_COUNTRY_DATA_RESET = 'GET_COUNTRY_DATA_RESET'